module.exports = __webpack_public_path__ + "img/patrulla_dif_up_selected.a513cd7d.svg";